import { render, staticRenderFns } from "./MessageStreamItem.vue?vue&type=template&id=354e60ec&scoped=true"
import script from "./MessageStreamItem.vue?vue&type=script&lang=js"
export * from "./MessageStreamItem.vue?vue&type=script&lang=js"
import style0 from "./MessageStreamItem.vue?vue&type=style&index=0&id=354e60ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e60ec",
  null
  
)

export default component.exports